// @flow
import { plans } from "./constants"
import type { Plan } from "./types"

export const getPlan = (title: string): Plan | void =>
  plans.find(plan => plan.title === title)




// WEBPACK FOOTER //
// ./src/data/plans/helpers.js